(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-gate"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'dog_age_verified';
    var gate = document.getElementById('age-gate');
    if (!gate) return;

    if (localStorage.getItem(KEY) === '1') {
      gate.hidden = true;
      return;
    }

    gate.hidden = false;

    document.getElementById('age-gate-yes').addEventListener('click', function () {
      localStorage.setItem(KEY, '1');
      gate.hidden = true;
    });

    document.getElementById('age-gate-no').addEventListener('click', function () {
      window.location.href = 'https://www.google.com';
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
